var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { SignInButton } from '@web/components/SignIn/SignInButton';
import { useTranslation } from 'react-i18next';
export var SignIn = function () {
    var t = useTranslation().t;
    return (_jsxs("div", __assign({ className: "flex" }, { children: [_jsx("div", __assign({ className: "md:w-1/2 flex w-full justify-center md:justify-end" }, { children: _jsxs("div", __assign({ className: " p-8 md:p-16 flex flex-col justify-center items-center md:items-start" }, { children: [_jsx("img", { src: "assets/img/logo-full.png", alt: "Workalizer Logo", className: "w-48 mb-8" }), _jsx("h1", __assign({ className: "text-lg leading-8 font-semibold text-gray-500" }, { children: t('login.description') })), _jsx(SignInButton, {})] })) })), _jsx("div", __assign({ className: "hidden md:block md:w-1/2 max-h-lvh" }, { children: _jsx("img", { src: "assets/img/others/sing-in-background.jpeg", alt: "Screenshot", className: "w-full h-full object-cover" }) }))] })));
};
